<tg-row class="summary-page-photos-media-section__header">
    <tg-col md="6" sm="12">
        <p class="p-lead-copy">Photos and media</p>
    </tg-col>
    <tg-col
        md="6"
        sm="12"
        class="summary-page-photos-media-section__header--right"
    >
        <a
            routerLink="../{{ stepIds.propertyPhotos }}"
            routerLinkActive="active"
            class="h-link-no-visited"
            >Edit photos and media</a
        >
    </tg-col>
</tg-row>
<tg-row>
    <tg-col class="summary-page-photos-media-section__content">
        <span class="summary-page-photos-media-section__content-label">
            Photos
        </span>
    </tg-col>
</tg-row>
<tg-row *ngIf="photos.length === 0">
    <tg-col>
        <span class="summary-page-photos-media-section__content-value">
            No photos
        </span>
    </tg-col>
</tg-row>
<tg-row *ngIf="photos.length > 0">
    <tg-col
        *ngFor="let photo of photos; index as i"
        aria-label="listing photo"
        class="summary-page-photos-media-section__photo"
        role="listitem"
        sm="6"
        lg="3"
    >
        <tm-list-photo-card
            [activatable]="false"
            [photo]="photo"
            attr.aria-label="photo {{ i + 1 }} of {{ photos.length }}"
            tabindex="0"
        >
            <tg-icon
                class="summary-page-photos-media-section__photo--main"
                *ngIf="i === 0"
                name="star-fill"
                role="presentation"
            >
            </tg-icon>
        </tm-list-photo-card>
    </tg-col>
</tg-row>
<tg-row>
    <tg-col
        class="
            summary-page-photos-media-section__content
            summary-page-photos-media-section__media
        "
    >
        <span class="summary-page-photos-media-section__content-label"
            >YouTube video:</span
        >
        {{ youTubeVideoUrl }}
    </tg-col>
</tg-row>
<tg-row>
    <tg-col
        class="
            summary-page-photos-media-section__content
            summary-page-photos-media-section__media
        "
    >
        <span class="summary-page-photos-media-section__content-label"
            >3D tour URL:</span
        >
        {{ threeDTourUrl }}
    </tg-col>
</tg-row>
